<template>
  <div>
    <div v-for="(item, index) in infoData" :key="index">
      <multiple-choice
        v-if="item.type == 0"
        :infoData="item"
        :index="index + 1"
      ></multiple-choice>
      <mulit-select v-if="item.type == 1" :infoData="item" :index="index + 1">
      </mulit-select>
      <gap-filling v-if="item.type == 2" :infoData="item" :index="index + 1">
      </gap-filling>
      <file-up-load v-if="item.type == 3" :infoData="item" :index="index + 1">
      </file-up-load>
    </div>
  </div>
</template>
<script>
import FileUpLoad from "./FileUpLoad.vue";
import GapFilling from "./GapFilling.vue";
import MulitSelect from "./MulitSelect.vue";
import MultipleChoice from "./MultipleChoice.vue";
export default {
  components: { MultipleChoice, MulitSelect, GapFilling, FileUpLoad },
  name: "CheckStatistics",
  props: {
    infoData: {
      type: Array
    }
  },
  data() {
    return {};
  }
};
</script>
